// extracted by mini-css-extract-plugin
export var avatarContainer = "_3i-1";
export var largeAvatarContainer = "_3i-2";
export var smallAvatarContainer = "_3i-0";